import type { RunDetailCard } from "../../api/models";
import { verdictRank } from "../../lib/verdict";

export function sortRunCards(cards: RunDetailCard[]): RunDetailCard[] {
  return [...cards].sort(
    (a, b) => verdictRank(a.scored.verdict) - verdictRank(b.scored.verdict) || a.cardId - b.cardId,
  );
}
